import { render } from "./App.vue?vue&type=template&id=c3e6ec44"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c3e6ec44&lang=scss"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__